'use client';
import ShareProject from '@/components/organisms/project-builder/share-project';

interface TasticProps {
  data: any;
  params?: any;
  searchParams?: any;
  categories?: any;
}
import { useSearchParams } from 'next/navigation';

const ShareProjectTastic = ({ data }: TasticProps) => {
  const searchParams = useSearchParams();
  const projectIdToEdit = searchParams.get('projectId') as string;
  const projectFormData:any = {};
  projectFormData.shoppingListId = projectIdToEdit;
  
  return (
    <>
      <ShareProject
        data={data?.data_banner}
        projectFormData={projectFormData}
      />
    </>
  );
};

export default ShareProjectTastic;
